import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MonitoramentoService {

  public baseUrlservice: string

  constructor(private httpClient: HttpClient) {
    this.baseUrlservice = environment.URL_API;
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
    })
  };

  public buscar(url: string): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlservice}${url}`, this.httpOptions);
  }

}
